import { IContact } from "@/store/contacts/types";

/**
 * @deprecated Prefer feature flags instead.
 * If this is a debug tool, you can also throw this under the toggle-able debug menu.
 *
 * We want to ensure that even admin users can "see" the product as a normal user.
 */
export const isMemAccount = (contact?: IContact) => {
  return (
    !!contact?.profileEmailAddress.endsWith("@mem.ai") ||
    contact?.profileEmailAddress == "copilotpriscilla@gmail.com" ||
    contact?.profileEmailAddress == "copilotkevin1@gmail.com" ||
    contact?.profileEmailAddress == "alex.o.tsai@gmail.com" ||
    contact?.profileEmailAddress == "tarek.mhtsb@gmail.com" ||
    contact?.profileEmailAddress == "xujenna@gmail.com" ||
    contact?.profileEmailAddress == "priscillamok@gmail.com" ||
    contact?.profileEmailAddress == "kennedylee1010@gmail.com"
  );
};
